/** Active custom warehouse: has customId and is not soft-deleted */
export const isActiveCustomWarehouse = (
    warehouse: { customId?: number | null; customDeleted?: number | boolean | null } | null | undefined,
): boolean => {
    if (!warehouse || !(Number(warehouse.customId) > 0)) return false;
    return !Number(warehouse.customDeleted);
};
